import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { PullLocationsModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/inputs/locations/pull-locations.model';
import React from 'react';
import { SubmitErrorHandler } from 'react-hook-form';

import { usePullEmspBoLocationContext } from '../../emsp-bo-location.context';
import { EmspBoLocationPullCreateFormStep1Controller } from '../emsp-bo-location-pull-create-form-step-1/emsp-bo-location-pull-create-form-step-1.controller';

interface EmspBoLocationPullCreateFormControllerProps {
  onError: SubmitErrorHandler<PullLocationsModel>;
  onSubmit: SubmitHandlerWithDirtyFields<PullLocationsModel>;
  onCancel: () => void;
  state: MultiStepFormState;
}

export const EmspBoLocationPullCreateFormController = (
  props: EmspBoLocationPullCreateFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel, state } = props;
  const data = usePullEmspBoLocationContext();

  return (
    <MultiStepFormProvider<PullLocationsModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      state={state}
      items={[
        {
          fields: ['cpoId'],
          component: <EmspBoLocationPullCreateFormStep1Controller />,
        },
      ]}
    />
  );
};
